import { Component, OnInit } from '@angular/core';
import { WebPage } from './components/shared/web-page';

@Component({
    selector: 'app-root',
    template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit{
    ngOnInit(): void {
    }    
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts